export const SET_THEMES = 'SET_THEMES';

// initial state
const state = {
    list: {},
}

// getters
const getters = {
    themes: state => state.list,
}

// actions
const actions = {
    getThemes: ({ commit, state }, payload) => {
        axios.get(laroute.route('api.themes.index'))
            .then((response) => {
                commit(SET_THEMES, {
                    themes: response.data.data
                });
            })
    },
}

// mutations
const mutations = {
    [SET_THEMES]: (state, payload) => {
        state.list = Object.assign({}, state.list, payload.themes);
    },
}

export default {
    state,
    getters,
    actions,
    mutations
}
